// extracted by mini-css-extract-plugin
export var cookienotification = "cookienotification-module--cookienotification--MJbgl";
export var cookienotification_visible = "cookienotification-module--cookienotification_visible--v4U5a";
export var cookienotification__text = "cookienotification-module--cookienotification__text--EbuPP";
export var cookienotification__textLink = "cookienotification-module--cookienotification__textLink--IUvK3";